import React, { useEffect, useState } from 'react';
import SidebarMenu from '../Widgets/SideBar Menu/SidebarMenu';
import Loader from '../Widgets/Loader/Loader';
import { useLocation, useNavigate } from 'react-router-dom';
import { downloadExcelReportingAPI, downloadPDFReportingAPI, getLogsDataAPI, getReportingDataAPI, getReportingMenuAPI, getStageWiseStatusAPI } from '../../api';
import { toast } from 'react-toastify';
import { Col, Tooltip } from 'react-bootstrap';
import { FaCaretDown } from 'react-icons/fa';


const LogsTable = () => {

    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const staff_name = params.get('name');
    const admin_id = params.get('id');
    const employee_type = params.get('employee_type');

    const [loading, setLoading] = useState(false);

    const [ExtraData, setExtraData] = useState();

    // const [dataPerPageButton, setDataPerPageButton] = useState("10");
    // const [currentPage, setCurrentPage] = useState(1);

    // Initialize state from localStorage or default values
    const [dataPerPageButton, setDataPerPageButton] = useState(() => {
        const storedValue = localStorage.getItem("reporting_dataPerPageButton");
        return storedValue ? JSON.parse(storedValue) : "10";
    });

    const [currentPage, setCurrentPage] = useState(() => {
        const storedValue = localStorage.getItem("reporting_currentPage");
        return storedValue ? JSON.parse(storedValue) : 1;
    });



    const handleDataPerPageChange = (e) => {
        const newDataPerPage = e.target.value;
        setDataPerPageButton(newDataPerPage);

        const formdata = new FormData();
        // formdata.append("page", currentPage);
        formdata.append("admin_access_id", admin_id);
        formdata.append("page", 1);

        formdata.append("itemsPerPage", newDataPerPage);
        formdata.append("status", status);
        formdata.append("from_date", from_date);
        formdata.append("to_date", to_date);



        localStorage.setItem("reporting_currentPage", 1);
        setCurrentPage(1);


        localStorage.setItem('startPage_admin_reporting', 1);
        setStartPage(1);


        getReportingDataFunction(formdata);
    };

    const today = new Date().toLocaleDateString('en-CA', {
        timeZone: 'Australia/Brisbane'
    });
    const [status, setStatus] = useState("");
    const [tm, setTM] = useState(admin_id);
    const [tms, setTMS] = useState([]);
    
    
    const [statuses, setStatuses] = useState([{
        "online": "Online",
    },{
        "lunch": "Break"
    }
    ]);


    const getCurrentDate = () => {
        const today = new Date();
        const yyyy = today.getFullYear();
        const mm = String(today.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const dd = String(today.getDate()).padStart(2, '0');
        return `${yyyy}-${mm}-${dd}`;
    };

    const [from_date, setFrom_date] = useState(getCurrentDate());
    const [to_date, setTo_date] = useState(getCurrentDate());


    const [totalHours, setTotalHours] = useState("00:00:00");
    const [pageTotalHours, setPageTotalHours] = useState("00:00:00");
    


    const [originalData, setOriginalData] = useState([]);

    const getReportingDataFunction = async (data) => {
        try {
            setLoading(true);

            // Appending Manger role information to the form data
            data.append("employee_type", employee_type);


            const response = await getLogsDataAPI(data);
            setLoading(false);
            if (
                response &&
                response?.data &&
                response?.data?.response &&
                response?.data?.response?.response === true &&
                response?.data?.response?.data
            ) {
                // console.log(response?.data?.response?.data?.data);
                setOriginalData(response?.data?.response?.data?.data);
                setExtraData(response?.data?.response?.data?.pagination);
                setTMS(response?.data?.response?.data?.all_staffs);

                setTotalHours(response?.data?.response?.data?.total_hours);
                setPageTotalHours(response?.data?.response?.data?.page_total_hours);

                // Make sure to set the from_date and to_date to the last date of employee if the employee is ex_employee
                setFrom_date(response?.data?.response?.data?.employee_last_date);
                setTo_date(response?.data?.response?.data?.employee_last_date);


            } else {
                setLoading(false);
                console.error(
                    "Error fetching reporting data:",
                    response?.data?.error_msg || "Unknown error"
                );
            }
        } catch (error) {
            setLoading(false);
            console.error("Error fetching reporting data:", error);
        }
    };

    useEffect(() => {
        const formdata = new FormData();
        formdata.append("admin_access_id", admin_id);
        formdata.append("page", currentPage);
        formdata.append("itemsPerPage", dataPerPageButton);


        formdata.append("status", "");
        
        formdata.append("from_date", "");
        formdata.append("to_date", "");
        
        

        getReportingDataFunction(formdata);
    }, []);




    const totalPages = Math.ceil(ExtraData?.totalRows / dataPerPageButton);
    const visiblePages = 4;



    const [startPage, setStartPage] = useState(() => {
        const savedStartPage = localStorage.getItem('startPage_admin_reporting');
        return savedStartPage ? Number(savedStartPage) : 1;
    });

    // useEffect(() => {
    //     fetchPageData(currentPage);
    // }, [currentPage, startPage]);

    const fetchPageData = (pageNumber) => {

        const formdata = new FormData();
        formdata.append("admin_access_id", admin_id);
        formdata.append("page", pageNumber);
        formdata.append("itemsPerPage", dataPerPageButton);
        
        formdata.append("status", status);
        
        formdata.append("from_date", from_date);
        formdata.append("to_date", to_date);
        // Your data fetching function
        getReportingDataFunction(formdata);
    };

    const handlePageClick = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const handleFirst = () => {
        setCurrentPage(1);
        setStartPage(1);
    };

    const handleLast = () => {
        const lastPage = totalPages;
        setCurrentPage(lastPage);
        const newStartPage = Math.max(1, lastPage - visiblePages + 1);
        setStartPage(newStartPage);
    };

    const handlePrev = () => {
        if (startPage > 1) {
            const newStartPage = Math.max(1, startPage - visiblePages);
            setStartPage(newStartPage);
            setCurrentPage(newStartPage);
        }
    };

    const handleNext = () => {
        if (startPage + visiblePages <= totalPages) {
            const newStartPage = startPage + visiblePages;
            setStartPage(newStartPage);
            setCurrentPage(newStartPage);
        }
    };



    const onSearch = () => {
        handleFirst();
        const onSearchFormData = new FormData();
        if(tm){
            onSearchFormData.append("admin_access_id", tm);
        }
        else{
            onSearchFormData.append("admin_access_id", admin_id);
        }
        
        onSearchFormData.append("page", currentPage);
        onSearchFormData.append("itemsPerPage", dataPerPageButton);
        onSearchFormData.append("status", status);
        onSearchFormData.append("from_date", from_date);
        onSearchFormData.append("to_date", to_date);

        getReportingDataFunction(onSearchFormData);

    };
    const onRefresh = () => {
        setDataPerPageButton("10");
        setCurrentPage(1);
        setFrom_date("");
        setTo_date("");
        setStatus("");
        const formdata = new FormData();
        formdata.append("admin_access_id", admin_id);
        formdata.append("page", 1);
        formdata.append("itemsPerPage", 10);
        
        formdata.append("status", "");
        formdata.append("from_date", "");
        formdata.append("to_date", "");

        getReportingDataFunction(formdata);
    };
    const onFromDateChange = (e) => {
        setFrom_date(e.target.value);
    };
    const onToDateChange = (e) => {
        setTo_date(e.target.value);
    };

    const onStatusChange = (e) => {
        setStatus(e.target.value);
    };

    const onTMChange = (e) => {
        setTM(e.target.value);
        // Find the selected id from the tms array
        const selectedTM = tms.find(tm => tm.id === e.target.value);
        // console.log("selectedTM", selectedTM?.employee_last_date);

        // If the selected TM is an ex-employee, set the from_date and to_date to the last date of the employee
        setFrom_date(selectedTM?.employee_last_date);
        setTo_date(selectedTM?.employee_last_date);
        // END

        // // After changing the TM, we will automatically click the search button to filter the data based on the selected TM
        // onSearch();
        // // END

    };


    return (

        <>
            {loading && <Loader />}

            <div className="main_desktop">
                <hr className="mb-2 thick-hr" />

                <div className="main-wrapper">
                    <div className="sub-wrapper-sidebar">
                        <SidebarMenu />
                    </div>

                    <div className="sub-wrapper-main mb-5">
                        <div className="main-heading-title">
                            <h3 className="heading-admin-title text-color-green ml-2">
                                {/* {staff_name} Logs */}
                                {employee_type == "aqato" ? "Logs (Current Employees)" : "Logs (Ex-Employees)"}
                            </h3>
                        </div>


                        <div className="container-- mx-0 mt-4">

                            <div className="table-responsive bg-white p-2 rounded">
                                <div className="row align-items-end sdrop mx-0 g-1">
                                    <Col lg="1" className=""
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            width: "50px",
                                        }}
                                    >
                                        <div
                                        >
                                            <select
                                                value={dataPerPageButton}
                                                onChange={handleDataPerPageChange}
                                                style={{
                                                    width: "100%",
                                                    padding: "6px",
                                                    border: "1px solid #ccc",
                                                    borderRadius: "5px",
                                                    boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                                                    appearance: "none", // Remove default arrow
                                                    WebkitAppearance: "none", // Safari compatibility
                                                    MozAppearance: "none", // Firefox compatibility
                                                    backgroundColor: "white",
                                                    cursor: "pointer",
                                                }}
                                            >
                                                <option value="10">10</option>
                                                <option value="25">25</option>
                                                <option value="50">50</option>
                                                <option value="100">100</option>
                                            </select>
                                            <FaCaretDown
                                                style={{
                                                    position: "absolute",
                                                    top: "50%",
                                                    right: "5px",
                                                    transform: "translateY(-50%)",
                                                    pointerEvents: "none", // Prevent interaction with the icon
                                                    fontSize: "14px",
                                                    color: "#333",
                                                }}
                                            />
                                        </div>
                                    </Col>
                                    <div className="col">
                                        <label>
                                            <b>From Date</b>
                                        </label>
                                        <input
                                            type="date"
                                            name="from_date"
                                            value={from_date}
                                            id="from_date"
                                            onChange={onFromDateChange}
                                            className="form-control"
                                            style={{
                                                cursor: "pointer",
                                                height: "calc(1.5em + .75rem + 2px)"
                                            }}
                                        />
                                    </div>
                                    <div className="col">
                                        <label>
                                            <b>To Date</b>
                                        </label>
                                        <input
                                            type="date"
                                            name="to_date"
                                            value={to_date}
                                            id="to_date"
                                            max={today}
                                            onChange={onToDateChange}
                                            className="form-control"
                                            style={{
                                                cursor: "pointer",
                                                height: "calc(1.5em + .75rem + 2px)"
                                            }}
                                        />
                                    </div>

                                    <div className="col">
                                        <label>
                                            <b>Status</b>
                                        </label>
                                        <select
                                            name="status"
                                            id="status"
                                            value={status}
                                            onChange={onStatusChange}
                                            className="form-select"
                                            style={{ cursor: "pointer" }}
                                        >
                                            <option value="">All</option>
                                            {statuses.map((status, index) => {
                                                const [key, value] = Object.entries(status)[0];
                                                return (
                                                    <option value={key} key={index}>
                                                        {value}
                                                    </option>
                                                );
                                            })}
                                        </select>
                                    </div>


                                    <div className="col">
                                        <label>
                                            <b>TM</b>
                                        </label>
                                        <select
                                            name="tm"
                                            id="tm"
                                            value={tm}
                                            onChange={onTMChange}
                                            className="form-select"
                                            style={{ cursor: "pointer" }}
                                        >
                                            {/* <option value="" disabled>-</option> */}
                                            {tms.map((tm, index) => {
                                                return (
                                                    <option value={tm?.id} key={index}>
                                                        {tm?.fullname}
                                                    </option>
                                                );
                                            })}
                                        </select>
                                    </div>
                                    

                                    <div className="col-1 d-flex exports_fun align-items-end">
                                        <button
                                            className="btn_green_yellow me-1 btn_report_search"
                                            onClick={onSearch}
                                        >
                                            <i className="bi bi-search"></i>
                                        </button>
                                        <button
                                            className="btn_yellow_green btn_report_search"
                                            onClick={onRefresh}
                                            title="Refresh"
                                        >
                                            <i className="bi bi-arrow-clockwise"></i>
                                        </button>


                                    </div>
                                </div>
                            </div>

                            <div id="table_wrapper" className="dataTables_wrapper no-footer">
                                <div class="container-fluid--">
                                    <div class="row">
                                        <div class="col-12">
                                            <div class="table-responsive table-wrapper">
                                                <table
                                                    class="table table-striped table-hover dataTable no-footer"
                                                    style={{ cursor: "default" }}
                                                >
                                                    <thead>
                                                        <tr>
                                                            <th
                                                                scope="col"
                                                                style={{ width: "5%" }}
                                                                className="th_font_size"
                                                            >
                                                                Date
                                                            </th>
                                                            <th
                                                                scope="col"
                                                                className="th_font_size"
                                                            >
                                                                Status
                                                            </th>
                                                            <th
                                                                scope="col"
                                                                style={{ width: "5%" }}
                                                                className="th_font_size"
                                                            >
                                                                Time in
                                                            </th>
                                                            <th
                                                                scope="col"
                                                                style={{ width: "10%" }}
                                                                className="th_font_size"
                                                            >
                                                                Time out
                                                            </th>
                                                            <th
                                                                scope="col"
                                                                style={{ width: "10%" }}
                                                                className="th_font_size"
                                                            >
                                                                Hours
                                                            </th>

                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        {originalData.map((item, index) => (
                                                            <tr
                                                                key={index}
                                                                className={index % 2 === 0 ? "even" : "odd"}
                                                            >
                                                                <td className="td_font_size">{item?.date}</td>
                                                                <td className="td_font_size">{item?.status}</td>

                                                                <td className="td_font_size">
                                                                    {item?.time_in}
                                                                </td>

                                                                <td className="td_font_size">{item?.time_out}</td>

                                                                <td className="td_font_size">{item?.total_hours}</td>

                                                            </tr>
                                                        ))}
                                                        {/* <tr>
                                                            <td colSpan={4} className='text-right'>Page Total Hours</td>
                                                            <td>{pageTotalHours}</td>
                                                        </tr> */}
                                                        <tr>
                                                            <td colSpan={4} className='text-right'>Total Hours</td>
                                                            <td>{totalHours}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <hr className="thick-hr" />

                                <div className="pagination-container p-3">
                                    <div className="dataTables_info">
                                        Showing {ExtraData?.totalRows ? ExtraData?.currentPage : 0} to{" "}
                                        {ExtraData?.totalRows ? ExtraData?.itemsPerPage : 0} of {ExtraData?.totalRows || 0}{" "}
                                        entries
                                    </div>




                                    <div className="pagination-buttons">
                                        <button
                                            className={`paginate_button ${currentPage === 1 ? "disabled" : ""}`}
                                            onClick={handleFirst}
                                            disabled={currentPage === 1}
                                        >
                                            First
                                        </button>

                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <button
                                                className={`paginate_button ${startPage === 1 ? "disabled" : ""}`}
                                                onClick={handlePrev}
                                                disabled={startPage === 1}
                                            >
                                                Previous
                                            </button>

                                            <div style={{ overflowX: 'auto', whiteSpace: 'nowrap', flex: 1 }}>
                                                {Array.from({ length: visiblePages }, (_, index) => {
                                                    const pageNumber = startPage + index;
                                                    if (pageNumber > totalPages) return null;

                                                    const isActive = currentPage === pageNumber;

                                                    return (
                                                        <button
                                                            key={pageNumber}
                                                            className={`paginate_button ${isActive ? "active" : ""}`}
                                                            style={{
                                                                display: 'inline-block',
                                                                margin: '0 4px',
                                                                backgroundColor: isActive ? "black" : "transparent",
                                                                color: isActive ? "white" : "black",
                                                            }}
                                                            onClick={() => handlePageClick(pageNumber)}
                                                        >
                                                            {pageNumber}
                                                        </button>
                                                    );
                                                })}
                                            </div>

                                            <button
                                                className={`paginate_button ${startPage + visiblePages - 1 >= totalPages ? "disabled" : ""}`}
                                                onClick={handleNext}
                                                disabled={startPage + visiblePages - 1 >= totalPages}
                                            >
                                                Next
                                            </button>
                                        </div>

                                        <button
                                            className={`paginate_button ${currentPage === totalPages ? "disabled" : ""}`}
                                            onClick={handleLast}
                                            disabled={currentPage === totalPages}
                                        >
                                            Last
                                        </button>
                                    </div>


                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>


        </>


    );
};

export default LogsTable;
